(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/payfooter-online.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/payfooter-online.js');

'use strict';

const {
  userSession
} = svs.core;
svs.numbergames.game.views.PayFooterOnline = Marionette.View.extend({
  modelEvents: {
    'change:isSubscription': 'changedIsSubscription',
    'change:syndicateId change:price': 'updateBalance'
  },
  behaviors() {
    return [{
      behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
      channel: svs.numbergames.game.huxfluxRadio
    }, {
      behaviorClass: svs.tur.start_subscription.behaviors.HandleSubscription,
      start: true,
      change: true
    }, {
      behaviorClass: svs.numbergames.game.behaviors.Payfooter,
      shouldShowSum: () => true,
      payButtonTitle: () => {
        if (this.model.get('isSubscription')) {
          return this.model.get('subscriptionId') ? 'Ändra ({amount} kr / vecka)' : 'Starta ({amount} kr / vecka)';
        }
        return 'Betala {amount} kr';
      },
      payfooterBalanceText: () => {
        if (this.model.get('isSubscription')) {
          return '';
        }
        if (this.model.get('isSyndicate')) {
          return 'Vårt saldo: {amount} kr';
        }
        return 'Mitt saldo: {amount} kr';
      },
      payfooterSumText: () => {
        if (this.model.get('isSubscription')) {
          return 'Summa: {amount} kr / vecka';
        }
        return 'Summa: {amount} kr';
      },
      analyticsEvents: this.getOption('analyticsEvents')
    }];
  },
  initialize() {
    svs.numbergames.game.logger.debug('PayFooter initialize');
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      if (!userSession.hasRole(userSession.roles.PLAYER) || this.model.get('numRowsExceedMax')) {
        return;
      }
      if (this.model.get('isValid')) {
        this.triggerMethod('pay');
      } else {
        this.listenToOnce(this.model, 'change:isValid', () => {
          this.radio.request('notifyOnAllHuxfluxEnd', () => this.triggerMethod('pay'));
        });
      }
    }
  },
  onPayfooterCreated() {
    this.updateBalance();
  },
  async updateBalance() {
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      return;
    }
    try {
      const activeAcc = await svs.numbergames.accountSelector.getActiveAccount();
      this.triggerMethod('updatePayfooterBalance', parseInt(activeAcc.balance, 10));
    } catch (e) {
      svs.numbergames.game.logger.error(e);
    }
  },
  changedIsSubscription() {
    this.triggerMethod('updatePayButtonTitle');
    this.triggerMethod('updatePayfooterSum');
    this.triggerMethod('updatePayButtonState');
    this.updateBalance();
  },
  onPay() {
    var _this$model$get;
    svs.numbergames.game.logger.debug('User wants to pay');
    if (this.model.get('isSubscription')) {
      const prefix = this.model.has('subscriptionId') ? 'change' : 'start';
      const wagerObject = this.model.toObject();
      const subscriptionObject = svs.numbergames.game_model.utils.subscriptionFromWager(wagerObject);
      this.triggerMethod("".concat(prefix, "Subscription"), subscriptionObject);
      return;
    }
    const ticketsCollection = this.model.get('tickets');
    const [ticketModel] = ticketsCollection.selectedTickets();
    const ticketData = ticketModel === null || ticketModel === void 0 ? void 0 : ticketModel.get('ticketData');
    const returnUrl = svs.utils.paramHandler.get({
      key: 'returnUrl'
    }).value;
    svs.numbergames.pay_numbergames.makePayment({
      onSuccessCb: () => this.model.removeFromLocalStorage(),
      onDoneCb: _ref => {
        let {
          wagerIds,
          successfulTickets,
          partialPaymentFailed
        } = _ref;
        if (returnUrl) {
          svs.utils.url.navigate("".concat(svs.utils.url.makeInternal(decodeURIComponent(returnUrl), svs.core.urlMapping.get('myBetsHome'))));
        } else {
          let relatedUrl = "".concat(svs.core.data.baseUrl, "/relaterat?grassrootstoasterredirect");
          if (wagerIds && wagerIds.length) {
            relatedUrl += "&wagerIds=".concat(wagerIds.join(','));
          }
          if (successfulTickets && successfulTickets.length) {
            var _successfulTickets$;
            const ticketAmount = successfulTickets.length;
            relatedUrl += "&tickets=".concat(ticketAmount);
            relatedUrl += "&ticketId=".concat((_successfulTickets$ = successfulTickets[0]) === null || _successfulTickets$ === void 0 ? void 0 : _successfulTickets$.wagerId);
          }
          if (partialPaymentFailed) {
            relatedUrl += '&partialPaymentFailed';
          }
          setTimeout(() => svs.utils.url.navigate(relatedUrl), 500);
        }
      },
      wagerData: {
        product: this.model.get('productId'),
        price: this.model.get('price'),
        drawCount: this.model.get('drawCount'),
        wagers: svs.numbergames.game.pay.toApiWagers(this.model.toObject()),
        prolongedWagerId: (_this$model$get = this.model.get('prolongedBet')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.wagerId
      },
      ticketData,
      showSuccessDialog: Boolean(returnUrl)
    });
  },
  onActivationSuccess() {
    this.model.removeFromLocalStorage();
  }
});

 })(window);